import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Document from "../../../custom/Document";
import KYCDoc from "./kycdoc";
import {API} from "../../../../config";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {Button} from "@material-ui/core";

const investorUploads = API.service('investors-uploaded-files');
const kyc_queries = API.service('kyc-query');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class InvestorWithdrawals extends Component {
    state={
        poid:[],
        questions:false,
        aCount:0,
        all:false,
        action:'',
        answers:false,
    };

    getKYC = () => {
        const app = this;
        let a = {};
        let blank = false;

        investorUploads.find({query:{_account:this.props.investor._account, _fieldname:this.props.document,$limit:1,$sort:{_creationdate:-1}}}).then(s=>{
            if((typeof s.data[0] !== 'undefined' && typeof s.data[0]._saved_question_answers !== undefined && s.data[0]._saved_question_answers !== null)){
                a = JSON.parse(s.data[0]._saved_question_answers);
            } else {
                blank = true;
            }

            app.setState({
                poid:s.data
            })

            kyc_queries.find({query:{document_class:this.props.document,active:1,$sort:{order:1}}}).then(values=>{
                let aCount = 0;
                let q = values.data;
                q.forEach((val,k) => {
                    if(blank === true){
                        a[val.id] = '';
                    }
                    q[k].answer_key = JSON.parse(val.answer_key);
                    aCount = (q[k].answer_key.length > aCount) ? q[k].answer_key.length : aCount;
                })

                let all = true;
                let action = 'accept';

                if(typeof s.data[0] !== 'undefined') {

                    if (s.data[0]._new_status === 'Accepted') {
                        action = 'approve'
                    }

                    if (s.data[0]._new_status === 'Approved') {
                        action = 'approve'
                    }
                }

                Object.keys(a).forEach(k=>{
                    console.log(k,a[k]);
                    if(a[k] === ''){
                        all = false;
                    }

                    if(a[k] !== 'yes'){
                        action = 'decline';
                    }
                })

                console.log(all);

                app.setState({
                    questions:q,
                    aCount: aCount,
                    all,
                    answers:a,
                    action
                })
            })
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.investor._id !== this.props.investor._id) {
            const app = this;
            this.setState({
                poid:[],
                poad:[],
            },app.getKYC());
        }
    }

    componentDidMount() {
        this.getKYC()
    }

    onComplete = () => {
        const app = this;
        this.setState({
            poid:[],
            poad:[],
        },app.getKYC());
    }

    handleChange = (e) => {
        let fieldId= e.target.name.replace('question-','');
        let answers = this.state.answers;
        answers[fieldId] = e.target.value
        let all = true;
        //let action = (this.state.poid[0]._new_status ==='Requires Attention') ? 'accept' : 'approve';
        let action = 'accept';
        if(this.state.poid[0]._new_status ==='Accepted'){
            action = 'approve'
        }

        if(this.state.poid[0]._new_status ==='Approved'){
            action = 'approve'
        }

        Object.keys(answers).forEach(k=>{
            console.log(k,answers[k]);
            if(answers[k] === ''){
                all = false;
            }

            if(answers[k] !== 'yes'){
                action = 'decline';
            }
        })

        console.log(all);

        this.setState({
            answers,
            all,
            action
        })
    }

    trigger = () => {
        this.props.updateState(this.state.answers, this.props.document, this.state.poid[0]._id, this.state.poid[0]._new_status, this.state.action)
    }

    render() {
        return (
            <React.Fragment>
                <div className={'flex'}>
                    <Paper className={'flex-1 mr-1'} style={{position:'relative', margin:5}}>

                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={"flex-1"}>
                                    {this.props.documentTitle}
                                </Typography>
                                <Document hideImage={true} investor={this.props.investor._account} type={this.props.document} label={this.props.documentTitle}
                                          placeholder='/assets/images/profile/default_photo.jpg' hideReviewStatus={true} onComplete={()=>this.onComplete()}/>
                            </Toolbar>
                        </AppBar>
                        <div className="p-12">

                        {this.state.poid.map((v,i)=>{
                            return (<React.Fragment>
                                <KYCDoc data={v} key={i} />
                            </React.Fragment>)
                        })}
                        </div>
                    </Paper>

                    <Paper className={'flex-1 mr-1'} style={{position: 'relative', margin: 5}}>
                        {(this.props.hideQuestions !== true) &&
                        <React.Fragment>
                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow: 'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={"flex-1"}>
                                    Documentary Suitability Questions
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        {(this.state.questions !== false) &&
                                <table>
                                <thead>
                                <tr>
                                <td style={{textAlign: 'center'}}>Yes</td>
                                <td style={{textAlign: 'center'}}>No</td>
                                <td>Question</td>
                                </tr>
                                </thead>
                                {this.state.questions.map((v, i) => {
                                    //console.log('wtf',this.state.answers);
                                    let bgcolor = ( this.state.answers !== null && this.state.answers[v.id] !== '') ? '#ff0000' : '';
                                    bgcolor = ( this.state.answers !== null && this.state.answers[v.id] === 'yes') ? '#00ff00' : bgcolor;
                                    return (
                                      <React.Fragment>
                                          {(v.answer_key.length === 2) &&
                                          <tr>
                                              {v.answer_key.map((a, b) => {
                                                  let bgcolor = (this.state.answers !== null && this.state.answers[v.id] === a.value && a.value === 'yes') ? '#00ff00' : '';
                                                  bgcolor = (this.state.answers !== null && this.state.answers[v.id] === a.value && a.value === 'no') ? '#ff0000' : bgcolor;
                                                  return (
                                                    <td style={{backgroundColor: bgcolor}}>
                                                        <Radio
                                                          checked={this.state.answers !== null && this.state.answers[v.id] === a.value}
                                                          onChange={this.handleChange}
                                                          value={a.value}
                                                          name={'question-' + v.id}
                                                          aria-label={a.value}
                                                        />
                                                    </td>
                                                  )
                                              })}
                                              <td>
                                                  {v.question}
                                              </td>
                                          </tr>
                                          }

                                          {(v.answer_key.length > 2) &&
                                          <tr>
                                              <td colSpan={2} style={{backgroundColor: bgcolor}}>
                                                  <Select
                                                    value={(this.state.answers !== null) ? this.state.answers[v.id] : ''}
                                                    onChange={this.handleChange}
                                                    name={'question-' + v.id}
                                                    style={{width: '100%'}}
                                                  >
                                                      <MenuItem value=''></MenuItem>
                                                      {v.answer_key.map((a, b) => {
                                                          return (
                                                            <MenuItem value={a.value}>{a.label}</MenuItem>
                                                          )
                                                      })}
                                                  </Select>
                                              </td>
                                              <td>
                                                  {v.question}
                                              </td>
                                          </tr>
                                          }
                                      </React.Fragment>
                                    )
                                })}
                                </table>
                            }

                            {(this.state.all) &&
                                <React.Fragment>
                                <Button variant="contained" color="secondary"
                                onClick={this.trigger}>{this.state.action}</Button>
                                </React.Fragment>
                            }
                        </React.Fragment>
                        }
                    </Paper>

                </div>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(InvestorWithdrawals)));
